define('gameday-index-gdaAuth/gameday-index-gdaAuth',['require','./src/main'],function(require){
  return require('./src/main');
});



